module.exports = __webpack_public_path__ + "img/Chatapp5.41e08df7.jpg";